<template>
  <a-layout-header class="hm-web-header">
    <div class="hm-web-header__toolbar">
      <div class="main">
        <div class="langue">
          <span
            v-for="(value, key) in langueMap"
            :key="value"
            :class="{'active': langue === value}"
            @click.stop="toggleLangue(value)"
          >
            {{ key }}
          </span>
        </div>
        <div class="actions">
          <span @click="gotoLogin">登录</span>
        </div>
      </div>
    </div>
    <div class="hm-web-header__menu" v-if="!showInviteJobHead">
      <div class="main">
        <div class="logo" @click.stop="gotoHome">
          <hmImg imgName="home_logo_01_zh" imgClass="hm-logo"/>
        </div>
        <hmMenu class="menu" />

        <div class="extra">
          <span class="hotline">400-6288-680</span>
          <a-dropdown overlayClassName="hm-web-menu__subMenu" placement="bottomCenter">
            <a-menu slot="overlay" @click="onApply">
              <a-menu-item key="taxsaas">华盟·税纪云</a-menu-item>
              <a-menu-item key="law">税纪云｜法规库</a-menu-item>
              <a-menu-item key="chataxera">金税一言</a-menu-item>
            </a-menu>
            <div class="main-btn">立即试用<a-icon type="down" /></div>
          </a-dropdown>
        </div>
      </div>
    </div>
      <div class="hm-web-header__menu " v-else>
        <div class="main inviteMain" >
          <div class="logo" @click.stop="gotoHome">
            <hmImg imgName="home_logo_01_zh" imgClass="hm-logo"/>
          </div>
          <inviteMenu class="menu" />
        </div>
    </div>
  </a-layout-header>
</template>

<script>
import { mapGetters } from 'vuex'
import hmMenu from '@/components/hm-menu/index'
import inviteMenu from '@/components/hm-menu/invite-job-index'

export default {
  name: 'hm-web-header',
  components: { hmMenu, inviteMenu },
  data () {
    return {
      langue: 'zh',
      langueMap: {
        '中': 'zh',
        'En': 'en',
        '日本语': 'jp'
      }
    }
  },
  computed: {
    ...mapGetters([
      'SSO_ADDRESS',
      'LAW_APPLY_URL',
      'OLD_WEB_SITE_URL'
    ]),
    // 校园招聘和社会招聘的页面head不一样
    showInviteJobHead () {
      return this.$route.name == 'social-recruitment' || this.$route.name=='campus-recruitment' || this.$route.name == 'social-recruitment-detail'
    }
  },
  methods: {
    toggleLangue (lang) {
      this.langue = lang
      if (['en', 'jp'].includes(this.langue)) {
        // TODO: 英文版和日文版还有内容要改动, 先不上线
        window.location.href = `${this.OLD_WEB_SITE_URL}${this.langue}`
      } else {
        this.$router.push({ path: `/${lang}` })
      }
    },
    onApply ({key}) {
      console.log('%c试用', 'background-color: green;color: #fff;', key)
      const applyMap = {
        'taxsaas': this.gotoTryout,
        'law': this.gotoLawApply,
        'chataxera': this.gotoChataxera
      }
      applyMap[key]()
    },
    gotoLogin () {
      this.openNewWindow(this.SSO_ADDRESS)
    },
    gotoLawApply () {
      this.openNewWindow(this.LAW_APPLY_URL)
    },
    gotoTryout () {
      this.$router.push({ name: 'tryOut' })
    },
    gotoHome () {
      this.$router.push({ name: 'home' })
    },
    openNewWindow (url) {
      window.open(url, '_blank')
    },
    gotoChataxera () {
      this.openNewWindow('https://chataxera.huamengtech.com/')
    }
  }
}
</script>

<style lang="less">
@core-width: 1200PX;
#hm-web {
  .hm-web-header {
    position: fixed;
    width: 100%;
    height: 88PX;
    line-height: 88PX;
    padding: 0;
    z-index: 999;
    user-select: none;
    &__toolbar {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 24PX;
      line-height: 24PX;
      background-color: #292F3A;
      overflow: hidden;
      .main {
        display: flex;
        justify-content: flex-end;
        width: @core-width;
        height: 100%;
        .langue {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          height: 100%;
          padding-left: 22PX;
          color: #848D9E;
          background-image: url('~@/assets/icons/icon_langue.png');
          background-repeat: no-repeat;
          background-size: 16PX;
          background-position: left center;
          user-select: none;
          transition: color cubic-bezier(0.075, 0.82, 0.165, 1) .5s;
          span {
            display: inline-block;
            height: 100%;
            line-height: 24PX;
            cursor: pointer;
            margin-left: 8PX;
            &.active,
            &:hover {
              color: #D8DDE6;
            }
          }
        }
      }

      .actions {
        color: #D8DDE6;
        margin-left: 48PX;
        cursor: pointer;
      }
    }
    &__menu {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 64PX;
      line-height: 64PX;
      background-color: #fff;
      border-bottom: 1PX solid #E8EEF8;
      .main {
        display: flex;
        position: relative;
        width: @core-width;
        height: 100%;
      }
      .inviteMain{
        justify-content: space-between;
        .menu{
          flex: none;
        }
      }
      .menu {
        flex: 1;
      }
      .logo {
        width: 100PX;
        margin-right: 56PX;
        cursor: pointer;
      }
      .extra {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 270PX;
        .hotline {
          font-size: 16PX;
          font-weight: 600;
          color: #292F3A;
          padding-left: 24PX;
          margin-right: 24PX;
          background-image: url('~@/assets/icons/icon_phone.png');
          background-repeat: no-repeat;
          background-size: 16PX;
          background-position: left center;
          user-select: none;
        }
      }
    }

    .main-btn {
      width: 88PX;
      height: 32PX;
      line-height: 32PX;
      background-image: linear-gradient(113deg, #3E77FF 0%, #3BA7FC 100%, #68A4F2 100%);
      box-shadow: 0PX 2PX 2PX 0PX rgba(0, 0, 0, 0.16);
      color: #fff;
      border: none;
      font-size: 12PX;
      padding: 0 12PX;
      border-radius: 2PX;
      cursor: pointer;
      i {
        margin-left: 4PX;
      }
      &:hover {
        color: #fff;
        opacity: .8;
      }
    }
    .hm-logo {
      width: auto;
      height: 40PX;
    }
  }
}
.hm-web-menu__subMenu {
  .ant-dropdown-menu {
    top: 18PX;
  }
  .ant-dropdown-menu-item {
    padding: 9PX 24PX;
  }
  .ant-dropdown-menu-item:hover {
    opacity: 0.8;
    background-color: #fff;
    color: #1890ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/header/index.vue